import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Container, Box, useToast } from "@chakra-ui/react";
import BreadcrumbComponent from "../../components/BreadcrumbComponent/BreadcrumbComponent";
import { faNewspaper, faBriefcase, faFileInvoice, faChartPie } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import c from "../../constant"
import ChartDataEditor from "./Components/ChartDataEditor"
import LineChartDataEditor from "./Components/LineChartDataEditor"
import { gql, useMutation, useLazyQuery } from '@apollo/client';

const QUERY_GRAPH = gql`
    query  {
        getGraphData{
        id
        data
        updatedAt
        updatedBy
        type
        }
    }
`;

const UPDATE_GRAPH_MUTATION = gql`
    mutation (
        $data: String
        $type: String
    ) {
        saveGraphData(
            data: $data
            type: $type
        )
    }
`;

function Website() {
    const { t } = useTranslation();
    const [loadArticle, { error, loading, data }] = useLazyQuery(QUERY_GRAPH)
        
    const [updatedGraph, { loading:loadingUpdateGraph, error:errorUpdateGraph, data: dataUpdateGraph }] = useMutation(UPDATE_GRAPH_MUTATION);
      const toast = useToast()

    useEffect(() => {
        loadArticle()
        window.scrollTo(0, 0);
    }, []);

    function getDataByType(type){
        let res = null
        if(data?.getGraphData){
            data?.getGraphData?.map((item)=>{
                if(item?.type===type){
                    res = item
                }
            })
        }
        return res
    }

    useEffect(()=>{
        if(dataUpdateGraph){
            toast({
                title: 'Data updated.',
                status: 'success',
                duration: 2000,
                isClosable: true,
            })
        }
    },[dataUpdateGraph])
    
    return (
        <>
            <Container maxW="container.xl" mt="16px" mb="16px">
                <BreadcrumbComponent
                    list={[
                        {
                            name: 'WEBSITE',
                            path: '/website',
                        },
                        {
                            name: 'GRAPH',
                            path: '#',
                        },
                    ]}
                />
                {data&&<Box pb="32px" w="100%" mt="5">
                    
                    <ChartDataEditor 
                        onSave={(data)=>{
                            updatedGraph({
                                variables:{
                                    type:'premium',
                                    data: data? JSON.stringify(data):null
                                }
                            })
                        }}
                        initData={getDataByType('premium')}
                    />
                    <Box h="4"/>
                    <LineChartDataEditor
                        onSave={(data)=>{
                            updatedGraph({
                                variables:{
                                    type:'density',
                                    data: data? JSON.stringify(data):null
                                }
                            })
                        }}
                        initData={getDataByType('density')}
                    />
                </Box>}
            </Container>
        </>
    );
}

export default Website;

